import logo from './logo.svg';
import './App.css';
import Component from './Componet';

function App() {
  return (
   <>
   <Component />
   </>
  );
}

export default App;
